export default function markdownToPlainText(markdown: string) {
    return (
        markdown
            // Remove images: ![alt](url)
            .replace(/!\[.*?\]\(.*?\)/g, '')

            // Convert links: [text](url) -> text
            .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')

            // Remove inline code: `code`
            //.replace(/`([^`]+)`/g, '$1')

            // Remove bold/italic/strikethrough: **text**, *text*, __text__, _text_, ~~text~~
            .replace(/(\*\*|__)(.*?)\1/g, '$2')
            //.replace(/(\*|_)(.*?)\1/g, '$2')
            .replace(/~~(.*?)~~/g, '$1')

            // Remove headers only at line start: # Header
            .replace(/^(#{1,6})\s+/gm, '')

            // Remove blockquotes only at line start: > Quote
            //.replace(/^>\s?/gm, '')

            // Remove list markers only at line start: -, *, +, or numbered lists
            //.replace(/^(\s*[-*+]\s+)/gm, '')
            //.replace(/^\s*\d+\.\s+/gm, '')

            // Remove horizontal rules
            //.replace(/^(-{3,}|\*{3,}|_{3,})$/gm, '')

            // Undo Lexical's markdown escapes: \* \_ \` \~ \\ and "1\." at paragraph start
            .replace(/\\([*_`~\\.])/g, '$1')

            // Trim whitespace
            .trim()
    );
}
